import { Article } from "../interface";

export const articles: Article[] = [
  {
    title: "In punta di matita, L'arte al femminile di Emanuela Degan",
    preview:
      'Si intitola "In punta di matita" la mostra di Emanuela Degan che sarà inaugurata, oggi alle 12,30, allo "Spazio delle arti La Soffitta" all’interno dell’Unione operaia di Colonnata in piazza Rapisardi 6.a rassegna accoglie opere dell’artista, veneziana di nascita e ritrattista esperta...',
    link: "https://www.lanazione.it/firenze/cronaca/in-punta-di-matita-larte-al-femminile-di-emanuela-degan-89a7b296",
  },
  {
    title:
      "Il Filo  -  Il portale della Cultura del Mugello  -  Emanuela Degan",
    preview:
      "Innamorata della rappresentazione delle figure umane e dei loro sentimenti ed emozioni, cerca di portare in ogni ritratto quella parte dell’essere umano che nessuno si ferma a guardare...",
    link: "https://cultura.ilfilo.net/emanuela-degan/",
  },
  {
    title: 'Alla Soffitta le opere di Emanuela Degan "In punta di matita"',
    preview:
      'SESTO FIORENTINO - "In punta di matita" è la mostra di Emanuela Degan allestita allo spazio delle Arti La Soffitta di Colonnata. La mostra che ospita 100 opere...',
    link: "https://www.piananotizie.it/alla-soffitta-le-opere-di-emanuela-degan-in-punta-di-matita/",
  },
];
